<template>
  <TextInput
    :label="label"
    :size="size"
    :disabled="disabled"
    :errorMessage="errorMessage"
  >
    <template #input>
      <input
        v-maska
        data-maska="##:##"
        type="text"
        :value="modelValue"
        :placeholder="placeholder"
        :name="label"
        maxlength="5"
        size="5"
        :disabled="disabled"
        :class="
          cn(
            inputVariants({
              size,
              disabled,
              hasError: !!errorMessage,
            }),
            props.class
          )
        "
        @maska="handleInput"
        @blur="handleBlur"
      />
    </template>
  </TextInput>
</template>

<script setup>
import { vMaska } from "maska";
import { TextInput, inputVariants } from "@/SharedComponents/Inputs";
import { cn } from "@/Utils/cn";

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
  modelValue: { type: String, required: true },
  label: { type: String, required: false },
  placeholder: { type: String, default: "00:00" },
  disabled: { type: Boolean, default: false },
  autoFocus: { type: Boolean, default: false },
  size: { type: String, required: false },
  errorMessage: { type: String, default: "" },
  class: { type: null, required: false },
});

function handleInput(e) {
  const { masked } = e.detail;
  let [hours, minutes] = masked.split(":");

  if (!minutes) {
    if (hours > 2 && hours < 10 && hours.length < 2) {
      return emit("update:modelValue", `0${hours}:`);
    }

    if (hours > 23) {
      hours = 23;
    }

    return emit("update:modelValue", `${hours}:`);
  }

  if (minutes > 5 && minutes < 10 && minutes.length < 2) {
    return emit("update:modelValue", `${hours}:0${minutes}`);
  }

  if (hours > 59) {
    hours = 59;
  }

  return emit("update:modelValue", `${hours}:${minutes}`);
}

function handleBlur() {
  let [hours, minutes] = props.modelValue.split(":");

  if (hours.length < 2) {
    hours = `0${hours}`;
  }

  if (minutes == 0) {
    emit("update:modelValue", `${hours}:00`);
    return;
  }

  if (minutes.length < 2) {
    emit("update:modelValue", `${hours}:0${minutes}`);
  }
}
</script>
